<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.4em">
            Visualizar dados do Veículo
        </v-card-title>
        <v-bottom-nav
            :active.sync="teste"
            color="primary"
            :value="true"
            dark
            shift
          >
            <v-btn dark @click="step = 1">
              <span>Veículo</span>
              <v-icon>airport_shuttle</v-icon>
            </v-btn>

            <v-btn dark @click="step = 2" v-if="veiculo.usuario">
              <span>Usuário</span>
              <v-icon>account_circle</v-icon>
            </v-btn>

            <v-btn dark @click="step = 3" v-if="veiculo.empresa">
              <span>Empresa</span>
              <v-icon>business</v-icon>
            </v-btn>

            <v-btn dark @click="step = 4" v-if="veiculo.motorista">
              <span>Funcionário</span>
              <v-icon>engineering</v-icon>
            </v-btn>

        </v-bottom-nav>
        <v-card-text>
            <v-stepper v-model="step" style="box-shadow: none" class="ma-0 pa-0">
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-layout wrap justify-space-between style="font-size: 1.2em">
                            <v-flex xs5 class="mb-1">
                                Placa: {{veiculo.identificacao}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.identificacao" class="mb-1">
                                Modelo e Marca: {{veiculo.identificacao}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.modelo" class="mb-1">
                                Modelo: {{veiculo.modelo}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.marca" class="mb-1">
                                Modelo: {{veiculo.marca}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.ano_fabricacao" class="mb-1">
                                Ano de fabricação: {{veiculo.ano_fabricacao}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.chassi" class="mb-1">
                                Chassi: {{veiculo.chassi}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.cor_texto" class="mb-1">
                                Cor em Texto: {{veiculo.cor_texto}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.cor" class="mb-1">
                                Cor: <v-btn small :color="formatarCor(veiculo.cor)"></v-btn>
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.ano_modelo" class="mb-1">
                                Ano do modelo: {{veiculo.ano_modelo}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.versao_motor" class="mb-1">
                                Versão do motor: {{veiculo.versao_motor}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.versao" class="mb-1">
                                Versão: {{veiculo.versao}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.capacidade" class="mb-1">
                                Capacidade: {{veiculo.capacidade}} Pessoas
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.qtd_assentos" class="mb-1">
                                Qtd assentos: {{veiculo.qtd_assentos}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.cilindradas" class="mb-1">
                                Cilindradas: {{veiculo.cilindradas}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.hp" class="mb-1">
                                HP: {{veiculo.hp}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.tipo_veiculo" class="mb-1">
                                Tipo veículo: {{veiculo.tipo_veiculo.denominacao}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.local_registro" class="mb-1">
                                Local de Registro: {{veiculo.local_registro}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.estado_registro" class="mb-1">
                                Estado de Registro: {{veiculo.estado_registro}}
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout
                            justify-center
                            class="mb-4"
                        >
                            <img
                                width="25%"
                                v-if="
                                veiculo.usuario &&
                                veiculo.usuario.pessoa &&
                                veiculo.usuario.pessoa.url_imagem_perfil"
                                :src="veiculo.usuario.pessoa.url_imagem_perfil"
                                alt="Logo da empresa"
                                style="border-radius: 10em"
                            >
                            <v-avatar
                                v-else
                                color="primary"
                                size="150"
                                dark
                            >
                                <v-icon size="100" color="white">account_circle</v-icon>
                            </v-avatar>
                        </v-layout>
                        <v-layout
                            wrap
                            justify-space-between
                            style="font-size: 1.2em"
                            v-if="veiculo.usuario && veiculo.usuario.pessoa"
                        >
                            <v-flex xs5 v-if="veiculo.usuario.pessoa" class="mb-1">
                                Nome Completo: {{veiculo.usuario.pessoa.nome_completo}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.usuario.pessoa.cpf" class="mb-1">
                                CPF: {{veiculo.usuario.pessoa.cpf}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.usuario.pessoa.data_cadastro" class="mb-1">
                                Data de cadastro: {{veiculo.usuario.pessoa.data_cadastro | formatDate('DD/MM/YYYY')}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.usuario.pessoa.data_nascimento" class="mb-1">
                                Data de Nascimento: {{veiculo.usuario.pessoa.data_nascimento | formatDate('DD/MM/YYYY')}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.usuario.pessoa.telefone" class="mb-1">
                                Telefone: {{formatarTelefone(veiculo.usuario.pessoa.telefone)}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.usuario.pessoa.email" class="mb-1">
                                E-mail: {{veiculo.usuario.pessoa.email}}
                            </v-flex>
                            <template v-if="veiculo.usuario.pessoa.endereco">
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.logradouro" class="mb-1">
                                    Logradouro: {{veiculo.usuario.pessoa.endereco.logradouro}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.numero" class="mb-1">
                                    Número: {{veiculo.usuario.pessoa.endereco.numero}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.bairro" class="mb-1">
                                    Bairro: {{veiculo.usuario.pessoa.endereco.bairro}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.cidade" class="mb-1">
                                    Cidade: {{veiculo.usuario.pessoa.endereco.cidade}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.estado" class="mb-1">
                                    Estado: {{veiculo.usuario.pessoa.endereco.estado}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.usuario.pessoa.endereco.cep" class="mb-1">
                                    CEP: {{formatarCep(veiculo.usuario.pessoa.endereco.cep)}}
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <v-layout
                            justify-center
                            class="mb-4"
                        >
                            <img
                                width="25%"
                                v-if="veiculo.empresa && veiculo.empresa.url_logo"
                                :src="veiculo.empresa.url_logo"
                                alt="Logo da empresa"
                                style="border-radius: 10em"
                            >
                            <v-avatar
                                v-else
                                color="primary"
                                size="150"
                                dark
                            >
                                <v-icon size="100" color="white">domain</v-icon>
                            </v-avatar>
                        </v-layout>
                        <v-layout
                            wrap
                            justify-space-between
                            style="font-size: 1.2em"
                            v-if="veiculo.empresa"
                        >
                            <v-flex xs5 v-if="veiculo.empresa.nome_fantasia" class="mb-1">
                                Nome Fantasia: {{veiculo.empresa.nome_fantasia}}
                            </v-flex>
                            <v-flex xs5 v-if="veiculo.empresa.cnpj" class="mb-1">
                                CNPJ: {{veiculo.empresa.cnpj}}
                            </v-flex>
                            <v-flex xs11 v-if="veiculo.empresa.razao_social" class="mb-1">
                                Razão Social: {{veiculo.empresa.razao_social}}
                            </v-flex>
                            <template v-if="veiculo.empresa.endereco">
                                <v-flex xs5 v-if="veiculo.empresa.endereco.logradouro" class="mb-1">
                                    Logradouro: {{veiculo.empresa.endereco.logradouro}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.empresa.endereco.numero" class="mb-1">
                                    Número: {{veiculo.empresa.endereco.numero}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.empresa.endereco.bairro" class="mb-1">
                                    Bairro: {{veiculo.empresa.endereco.bairro}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.empresa.endereco.cidade" class="mb-1">
                                    Cidade: {{veiculo.empresa.endereco.cidade}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.empresa.endereco.estado" class="mb-1">
                                    Estado: {{veiculo.empresa.endereco.estado}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.empresa.endereco.cep" class="mb-1">
                                    CEP: {{formatarCep(veiculo.empresa.endereco.cep)}}
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <v-layout
                            justify-center
                            class="mb-4"
                        >
                            <img
                                width="25%"
                                v-if="veiculo.motorista &&
                                      veiculo.motorista.pessoa &&
                                      veiculo.motorista.pessoa.url_imagem_perfil
                                    "
                                :src="veiculo.motorista.pessoa.url_imagem_perfil"
                                alt="Logo da empresa"
                                style="border-radius: 10em"
                            >
                            <v-avatar
                                v-else
                                color="primary"
                                size="150"
                                dark
                            >
                                <v-icon size="100" color="white">engineering</v-icon>
                            </v-avatar>
                        </v-layout>
                        <v-layout
                            wrap
                            justify-space-between
                            style="font-size: 1.2em"
                            v-if="veiculo.motorista"
                        >
                            <template v-if="veiculo.motorista.pessoa">
                                <v-flex xs5 v-if="veiculo.motorista.pessoa" class="mb-1">
                                    Nome Completo: {{veiculo.motorista.pessoa.nome_completo}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.pessoa.cpf" class="mb-1">
                                    CPF: {{veiculo.motorista.pessoa.cpf}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.pessoa.data_cadastro" class="mb-1">
                                    Data de cadastro: {{veiculo.motorista.pessoa.data_cadastro | formatDate('DD/MM/YYYY')}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.pessoa.data_nascimento" class="mb-1">
                                    Data de Nascimento: {{veiculo.motorista.pessoa.data_nascimento | formatDate('DD/MM/YYYY')}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.pessoa.telefone" class="mb-1">
                                    Telefone: {{formatarTelefone(veiculo.motorista.pessoa.telefone)}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.pessoa.email" class="mb-1">
                                    E-mail: {{veiculo.motorista.pessoa.email}}
                                </v-flex>
                                <template v-if="veiculo.motorista.pessoa.endereco">
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.logradouro" class="mb-1">
                                        Logradouro: {{veiculo.motorista.pessoa.endereco.logradouro}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.numero" class="mb-1">
                                        Número: {{veiculo.motorista.pessoa.endereco.numero}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.bairro" class="mb-1">
                                        Bairro: {{veiculo.motorista.pessoa.endereco.bairro}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.cidade" class="mb-1">
                                        Cidade: {{veiculo.motorista.pessoa.endereco.cidade}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.estado" class="mb-1">
                                        Estado: {{veiculo.motorista.pessoa.endereco.estado}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.pessoa.endereco.cep" class="mb-1">
                                        CEP: {{formatarCep(veiculo.motorista.pessoa.endereco.cep)}}
                                    </v-flex>
                                </template>
                            </template>
                            <template v-else>
                                 <v-flex xs5 v-if="veiculo.motorista.nome_email" class="mb-1">
                                    Nome Completo: {{veiculo.motorista.nome_email}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.cpf" class="mb-1">
                                    CPF: {{veiculo.motorista.cpf}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.data_cadastro" class="mb-1">
                                    Data de cadastro: {{veiculo.motorista.data_cadastro | formatDate('DD/MM/YYYY')}}
                                </v-flex>
                                <v-flex xs5 v-if="veiculo.motorista.email" class="mb-1">
                                    E-mail: {{veiculo.motorista.email}}
                                </v-flex>
                                <template v-if="veiculo.motorista.empresa">
                                    <v-flex xs5 v-if="veiculo.motorista.empresa.nome_fantasia" class="mb-1">
                                        Nome Fantasia: {{veiculo.motorista.empresa.nome_fantasia}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.empresa.cnpj" class="mb-1">
                                        CNPJ: {{veiculo.motorista.empresa.cnpj}}
                                    </v-flex>
                                    <v-flex xs11 v-if="veiculo.motorista.empresa.razao_social" class="mb-1">
                                        Razão Social: {{veiculo.motorista.empresa.razao_social}}
                                    </v-flex>
                                </template>
                                <template v-if="veiculo.motorista.endereco">
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.logradouro" class="mb-1">
                                        Logradouro: {{veiculo.motorista.endereco.logradouro}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.numero" class="mb-1">
                                        Número: {{veiculo.motorista.endereco.numero}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.bairro" class="mb-1">
                                        Bairro: {{veiculo.motorista.endereco.bairro}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.cidade" class="mb-1">
                                        Cidade: {{veiculo.motorista.endereco.cidade}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.estado" class="mb-1">
                                        Estado: {{veiculo.motorista.endereco.estado}}
                                    </v-flex>
                                    <v-flex xs5 v-if="veiculo.motorista.endereco.cep" class="mb-1">
                                        CEP: {{formatarCep(veiculo.motorista.endereco.cep)}}
                                    </v-flex>
                                </template>
                            </template>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
        <v-card-actions>
            <v-btn class="mb-1" block x-large @click="$emit('fechar')">Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['veiculo'],
    data: () => ({
        step: 1,
        teste: 0
    }),
    methods: {
        formatarCor (cor) {
            if (cor === null) return ''
            if (cor === undefined) return ''
            if (cor.length === 6) return `#${cor}`
            if (cor.length === 7) return cor
            if (cor.length === 9) return cor.slice(0, 7)
            else {
                let teste = parseInt(cor)
                teste = teste.toString(16)
                return `#${teste.slice(2, 8)}`
            }
        },
        formatarCep (cep) {
            if (!cep) return 'Indefinido'
            if (cep.length < 8) return 'Indefinido'
            if (cep.length === 8) return `${cep.slice(0, 5)}-${cep.slice(5, 8)}`
            return cep
        },
        formatarTelefone (telefone) {
            if (!telefone) return 'Indefinido'
            if (telefone.length < 8) return 'Indefinido'
            if (telefone.length === 8) return `${telefone.slice(0, 4)}-${telefone.slice(4, 8)}`
            if (telefone.length === 9) {
                if (telefone.search('-') === -1) return `${telefone[0]}${telefone.slice(1, 4)}-${telefone.slice(5, 9)}`
                return telefone
            }
            if (telefone.length === 10) return `+(${telefone.slice(0, 2)}) ${telefone.slice(2, 6)}-${telefone.slice(6, 10)}`

            if (telefone.length === 11) return `(${telefone.slice(0, 2)}) ${telefone[2]} ${telefone.slice(3, 7)}-${telefone.slice(7, 11)}`

            if (telefone.length === 14) return `${telefone.slice(0, 3)} (${telefone.slice(3, 5)}) ${telefone[5]} ${telefone.slice(6, 10)}-${telefone.slice(10, 14)}`

            return telefone
        }
    }
}
</script>
